import BackpackV2Icon from './component.jsx'
export default BackpackV2Icon
